import { ResolverTag } from '@ps/web-core-enums';
import { Translation, useResolver } from '@ps/web-shared-components';
import React from 'react';
import URL from 'url-parse';

import AccountIcon from '@swf/core/assets/icons/account-selected.svg';

import { TXTWCL_PokerStars_My_Account } from './AccountRamRedirect.messages.json';
import styles from './AccountRamRedirect.scss';

const AccountRamRedirect: React.FC = () => {
  const starsWebPoker = useResolver(ResolverTag.StarsWebPoker);
  const url = new URL(starsWebPoker, true);
  url.query.wc2l = 'starsReward';

  return (
    <a href={url.toString()} className={styles.container}>
      <AccountIcon className={styles.icon} />
      <span className={styles.text}>
        <Translation {...TXTWCL_PokerStars_My_Account} />
      </span>
    </a>
  );
};
export default AccountRamRedirect;
